module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-38.4efa9676.svg";